<template>
  <div class="add-node-btn-box">
    <div class="add-node-btn">
      <el-popover v-if="isWorkFlowView" placement="right-start" popper-class="add-node-popover" v-model="visible">
        <div class="add-node-popover-body">
          <div class="add-node-popover-item approver" @click="addType(1)">
            <div class="item-wrapper">
              <img src="/assets/basedict/approve.png" alt="" class="img-style">
            </div>
            <p>审批人</p>
          </div>
          <div class="add-node-popover-item notifier" @click="addType(2)">
            <div class="item-wrapper">
              <img src="/assets/basedict/cc.png" alt="" class="img-style">
            </div>
            <p>抄送人</p>
          </div>
          <div class="add-node-popover-item condition" @click="addType(4)" v-if="tip !== '条件'">
            <div class="item-wrapper">
              <img src="/assets/basedict/cond.png" alt="" class="img-style">
            </div>
            <p>条件分支</p>
          </div>
        </div>
        <button class="btn" type="button" slot="reference" v-if="!isNotifyNode">
          <i style="color:#fff" class="el-icon-plus"></i>
        </button>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  props: {
    childNodeP: {
      type: Object,
      default: () => {}
    },
    nodeConfig: {
      type: Object,
      default: () => {}
    },
    tip: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isWorkFlowView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      parentObj: {},
      isShow: true,
    }
  },
  computed: {
    isNotifyNode() {
      return this.nodeConfig && this.nodeConfig.type === 2;
    }
  },
  methods: {
    hasNotifyNode() {
      let currentNode = this.$parent.nodeConfig;
      while (currentNode) {
        if (currentNode.type === 2) {
          return true;
        }
        currentNode = currentNode.childNode;
      }
      return false;
    },
    addType(type) {
      this.visible = false;
      let data;
      if (type != 4) {
        if (type == 1) {
          data = {
            nodeName: "审核人",
            error: true,
            type: 1,
            nodeId: uuidv4(),
            examineMode: "1",
            nodeUserType: {
              type: '',
              value: '',
              valueList: [],
              valueName: '',
            },
            childNode: this.childNodeP,
          }
        } else if (type == 2) {
          if (this.hasNotifyNode()) {
            this.$message.warning('每个流程只能有一个抄送节点');
            return;
          }
          
          if (this.childNodeP) {
            this.$message.warning('抄送节点只能在流程最底部');
            return;
          }
          
          data = {
            nodeName: "抄送人",
            error: true,
            type: 2,
            nodeId: uuidv4(),
            nodeUserType: {
              type: 'manager',
              value: '',
              valueName: '',
              valueList: [],
            },
            childNode: null,
          }
        }
        this.$parent.setPerson('', '', data, this.tip);  //添加节点自动弹出弹框
      } else {
        data = {
          nodeName: "路由",
          type: 4,
          nodeId: uuidv4(),
          childNode: this.childNodeP,
          conditionNodes: [{
            nodeName: "条件",
            error: true,
            type: 3,
            priorityLevel: 1,
            conditionList: [],
            childNode: null,
          }, {
            nodeName: "条件",
            error: true,
            type: 3,
            priorityLevel: 2,
            conditionList: [],
            childNode: null
          }]
        }
        this.$parent.setPerson(1, '', data);//添加节点自动弹出弹框
      }
      this.$emit("update:childNodeP", data);
    }
  }
}
</script>
<style scoped lang="less">
.add-node-btn-box {
  width: 240px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    margin: auto;
    width: 2px;
    height: 100%;
    background-color: #cacaca
  }
  .add-node-btn {
    user-select: none;
    width: 240px;
    padding: 20px 0 32px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    flex-shrink: 0;
    -webkit-box-flex: 1;
    flex-grow: 1;
    .btn {
      outline: none;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);
      width: 30px;
      height: 30px;
      background: #3296fa;
      border-radius: 50%;
      position: relative;
      border: none;
      line-height: 30px;
      -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      .iconfont {
        color: #fff;
        font-size: 16px
      }
      &:hover {
        transform: scale(1.3);
        box-shadow: 0 13px 27px 0 rgba(0, 0, 0, .1)
      }
      &:active {
        transform: none;
        background: #1e83e9;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1)
      }
    }
  }
}
</style>
<style lang="less">
.add-node-popover-body {
  display: flex;
  .add-node-popover-item {
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    flex: 1;
    color: #191f25!important;
    .item-wrapper {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      margin-bottom: 5px;
      background: #fff;
      border-radius: 50%;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      .iconfont {
        font-size: 35px;
        line-height: 80px
      }
    }
    &.approver{
      .item-wrapper {
        color: #ff943e
      }
    }
    &.notifier{
      .item-wrapper {
        color: #3296fa
      }
    }
    &.condition{
      .item-wrapper {
        color: #15bc83
      }
    }
    &:hover{
      .item-wrapper {
        background: #3296fa;
        box-shadow: 0 10px 20px 0 rgba(50, 150, 250, .4)
      }
      .iconfont {
        color: #fff
      }
    }
    &:active{
      .item-wrapper {
        box-shadow: none;
        background: #eaeaea
      }
      .iconfont {
        color: inherit
      }
    }
  }
}
</style>
